var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPaste(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 320 320",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M203 76l69 0c17,0 31,14 31,32l0 180c0,18 -14,32 -31,32l-125 0c-17,0 -31,-14 -31,-32l0 -44 -69 0c-17,0 -31,-14 -31,-32l0 -180c0,-18 14,-32 31,-32l125 0c17,0 31,14 31,32l0 44zm-87 152l14 0 43 0c9,0 16,-7 16,-15l0 -67c-9,-2 -19,-4 -29,-4l0 15c0,2 -2,3 -4,3 -1,0 -2,0 -2,0l-59 -44c-1,-2 -2,-4 0,-6 0,0 0,-1 1,-1l58 -36c2,-1 4,-1 5,1 0,1 1,1 1,2l0 15c10,1 20,3 29,6l0 -65c0,-9 -7,-16 -16,-16l-127 0c-9,0 -16,7 -16,16l0 181c0,8 7,15 16,15l70 0zm14 16l0 44c0,9 7,16 16,16l127 0c9,0 16,-7 16,-16l0 -181c0,-8 -7,-15 -16,-15l-70 0 0 11c14,7 26,17 36,29 23,28 35,68 36,105 0,2 -1,4 -3,4 -2,0 -4,-1 -4,-3l0 0c-2,-6 -4,-12 -6,-17 -1,1 -2,2 -4,2l-56 0c-2,6 -6,11 -11,14l67 0c2,0 4,2 4,5l0 5c0,2 -2,4 -4,4l-97 0c-3,0 -5,-2 -5,-4l0 -3 -26 0zm73 -92l0 58 54 0c-8,-17 -19,-33 -32,-44 -7,-6 -14,-11 -22,-14zm-42 115l97 0c2,0 4,2 4,4l0 5c0,2 -2,4 -4,4l-97 0c-3,0 -5,-2 -5,-4l0 -5c0,-2 2,-4 5,-4z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPaste);
export default __webpack_public_path__ + "static/media/paste.be9fd90f.svg";
export { ForwardRef as ReactComponent };